import api from "@/configs/axios-config";

export type BuyerBossWithBuyerCode = {
  employee_id: string;
  email: string;
  name: string;
  buyer_code: string[];
};

export type BuyerBoss = {
  user_id: string;
  email: string;
  name: string;
  lastname: string;
};

export type UpdateBuyerBossPayload = {
  employee_id: string;
  buyer_code: string[];
};

export const getBuyerBossList = async (): Promise<BuyerBoss[]> => {
  const response = await api.get("/buyer-boss/buyer_boss_role_list");
  return response.data;
};

export const getBuyerBossWithBuyerCode = async (): Promise<
  BuyerBossWithBuyerCode[]
> => {
  const response = await api.get("/buyer-boss/");
  return response.data;
};

export const updateBuyerBoss = async (
  payload: UpdateBuyerBossPayload,
): Promise<void> => {
  await api.post(`/buyer-boss/${payload.employee_id}`, {
    buyer_code: payload.buyer_code,
  });
};

export const deleteBuyerBoss = async (employee_id: string): Promise<void> => {
  await api.delete(`/buyer-boss/${employee_id}`);
};

export const getAllBuyerCodes = async (): Promise<string[]> => {
  const response = await api.get("/buyer-boss/all");
  return response.data?.data;
};
